import { Route } from '@angular/router';
import {
  AppFrameComponent,
  LoginIfNotAuthenticated,
  LoginRedirect,
  LoginRedirectComponent,
} from '@unicup-ticketing/core';
import { HeroDashboardComponent } from './app/components/hero-dashboard/hero-dashboard.component';
import { ProfileComponent } from './app/components/profile/profile.component';
import { AboutTheDrawComponent } from './app/components/about-the-draw/about-the-draw.component';
import { FaqComponent } from './app/components/faq/faq.component';
import { ContactComponent } from './app/components/contact/contact.component';
import { LegalNoticeComponent } from './app/components/legal-notice/legal-notice.component';
import { DataPrivacyComponent } from './app/components/data-privacy/data-privacy.component';
import { UnauthorizedComponent } from '@unicup-ticketing/unauthorized';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AppFrameComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HeroDashboardComponent,
      },
      {
        path: 'about-the-draw',
        component: AboutTheDrawComponent,
      },
      {
        path: 'faq',
        component: FaqComponent,
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        path: 'legal-notice',
        component: LegalNoticeComponent,
      },
      {
        path: 'data-privacy',
        component: DataPrivacyComponent,
      },
      {
        path: 'login',
        redirectTo: 'profile',
      },
      {
        path: 'loginRedirect',
        component: LoginRedirectComponent,
        canActivate: [LoginRedirect],
      },
      {
        path: '401',
        component: UnauthorizedComponent,
        data: { redirectToIfLoggedIn: '/' },
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [LoginIfNotAuthenticated],
      },
      {
        path: 'draws/:drawId/register',
        loadChildren: () => import('@unicup-ticketing/registration').then(m => m.userRegistrationRoutes),
        canActivate: [LoginIfNotAuthenticated],
      },
    ],
  },
];
